'use client';

import Image from 'next/image';
import Link from 'next/link';

export default function KottonseedLogo() {
  return (
    <Link href="/" aria-label="코튼시드 메인으로 이동" className="flex w-[95px] items-center opacity-50">
      <Image
        src="https://cdn.kottonseed.io/assets/football/common/logo.webp"
        alt="코튼시드 로고"
        width={95}
        height={20}
      />
    </Link>
  );
}
